module.exports = __webpack_public_path__ + "static/media/team1.063ef3c7.png";